import * as React from 'react';
import { createSvg } from './utils/createSvg';
export var ErrorLarge = createSvg(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M40 0a40 40 0 1040 40A40 40 0 0040 0zm17.41 54.59a2 2 0 11-2.83 2.83L40 42.83 25.41 57.41a2 2 0 01-2.83-2.83L37.17 40 22.59 25.41a2 2 0 012.83-2.83L40 37.17l14.59-14.58a2 2 0 012.83 2.83L42.83 40z" })), '0 0 80 80', 'ErrorLarge');
//# sourceMappingURL=ErrorLarge.js.map